import startCase from 'lodash/startCase';
import moment from 'moment';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CONTRACT_FIXATION_GRANULARITY } from '../../constants';
import { useLocale } from '../../context/LocalContext';

const FormatPriodDateBloc = ({ granularity, date, periodMonths, format = 'MMMM YY', isCapitalize = false }) => {
  // Use to fix 1419 ticket
  const [t] = useTranslation();
  useLocale();

  let firstDate;

  if (granularity === CONTRACT_FIXATION_GRANULARITY.MONTH || (periodMonths && periodMonths === 1)) {
    firstDate = startCase(moment(date).locale('en').format(format));
  } else {
    firstDate = startCase(moment(date).locale('en').format(format));
  }

  const formattedStringDate = useMemo(() => {
    let stringDate;

    if (periodMonths && periodMonths === 1) stringDate = `${firstDate}`;
    if (periodMonths && periodMonths === 3) {
      stringDate = `Q${moment(date).quarter()} ${moment(date).format('YY')}`;
    }
    if (periodMonths && periodMonths === 6) {
      if (moment(date).format('M') === '4') stringDate = `${t('format-summer')} ${moment(date).format('YY')}`;
      else if (moment(date).format('M') === '10') stringDate = `${t('format-winter')} ${moment(date).format('YY')}`;
    }
    if (periodMonths && periodMonths === 12) {
      if (moment(date).format('M') === '1') stringDate = `CAL ${moment(date).add(11, 'month').format('YY')}`;
      if (moment(date).format('M') === '10') stringDate = `GY ${moment(date).format('YY')}`;
    }

    if (isCapitalize) {
      stringDate.toUpperCase();
    }

    return stringDate;
  }, [firstDate, date, isCapitalize, periodMonths, t]);

  return <div style={{ display: 'inline-block' }}>{formattedStringDate}</div>;
};

export default FormatPriodDateBloc;
